import { useState, useEffect } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

// The four places a page can be narrowed to. Zone and Subzone are the client's own sales
// territory and nest - one subzone sits in exactly one zone. State and City are geography and cut
// across both, so every list is narrowed by whatever else has been picked rather than by a fixed
// order: picking a State shortens the Subzone list just as picking a Subzone shortens the States.
const LEVELS = [
  { key: 'zone', path: '/geo/zones', all: 'All Zones', width: 'w-40' },
  { key: 'subzone', path: '/geo/subzones', all: 'All Subzones', width: 'w-40' },
  { key: 'state', path: '/geo/states', all: 'All States', width: 'w-40' },
  { key: 'city', path: '/geo/cities', all: 'All Cities', width: 'w-40' },
];

export function GeoFilters({ api, zone, setZone, subzone, setSubzone, state, setState, city, setCity,
  onReset, size }) {
  const picked = { zone, subzone, state, city };
  const setter = { zone: setZone, subzone: setSubzone, state: setState, city: setCity };
  const [lists, setLists] = useState({});

  // One request per dropdown, re-run when another pick changes what belongs in it.
  useEffect(() => {
    let live = true;
    LEVELS.forEach(({ key, path }) => {
      if (!setter[key]) return;
      const params = {};
      LEVELS.forEach(l => { if (l.key !== key && picked[l.key]) params[l.key] = picked[l.key]; });
      api.get(path, { params })
        .then(r => { if (live) setLists(p => ({ ...p, [key]: r.data })); })
        .catch(() => {});
    });
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, zone, subzone, state, city]);

  // A pick that no longer fits what is on screen is cleared, not left showing a stale slice.
  const pick = (key) => (v) => {
    setter[key](v === 'all' ? '' : v);
    if (key !== 'city' && setCity) setCity('');
    if (onReset) onReset();
  };

  const trigger = size === 'sm' ? 'h-8 text-xs' : size === 'md' ? 'h-9 text-sm' : '';

  return (
    <>
      {LEVELS.filter(l => setter[l.key]).map(({ key, all, width }) => (
        <Select key={key} value={picked[key] || 'all'} onValueChange={pick(key)}>
          <SelectTrigger className={`${width} ${trigger}`} data-testid={`filter-${key}`}>
            <SelectValue placeholder={all} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{all}</SelectItem>
            {(lists[key] || []).map(v => <SelectItem key={v} value={v}>{v}</SelectItem>)}
          </SelectContent>
        </Select>
      ))}
    </>
  );
}
